import React, { Component } from 'react'
import {
  Route, withRouter, Switch, Redirect
} from 'react-router-dom'
import { connect } from 'react-redux'

import AppLayout from '../../layout/AppLayout'
// import admin from './admin'
import main from './main'
import paraphrase from './paraphrase'
import paraphraseChatGPT from './paraphrase-chatgpt'
// import synonymous from './synonymous'
import summary from './summary'
import summaryChatGPT from './summary-chatgpt'
// import spintax from './spintax'
// import videos from './videos'
// import support from './support'
// import payments from './payments'
// import account from './account'

class App extends Component {
  render() {
    const { match } = this.props
    console.log('match.url:', match.url)

    return (
      <AppLayout>
        <Switch>
          {/* <Redirect exact from={`${match.url}/`} to={`${match.url}/paraphrase`} /> */}
          <Route exact path={`${match.url}/`} component={main} />
          {/* <Route path={`${match.url}/admin`} component={admin} /> */}
          <Route path={`${match.url}/paraphrase2`} component={paraphraseChatGPT} />
          <Route path={`${match.url}/paraphrase`} component={paraphrase} />
          {/* <Route path={`${match.url}/videos`} component={videos} /> */}
          <Route path={`${match.url}/summary2`} component={summaryChatGPT} />
          <Route path={`${match.url}/summary`} component={summary} />
          {/* <Route path={`${match.url}/synonymous`} component={synonymous} />
          <Route path={`${match.url}/spintax`} component={spintax} />
          <Route path={`${match.url}/support`} component={support} />
          <Route path={`${match.url}/payments`} component={payments} /> */}
          {/* <Route path={`${match.url}/account`} component={account} /> */}
          <Redirect to="/error" />
        </Switch>
      </AppLayout>
    )
  }
}

// eslint-disable-next-line no-shadow
const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu
  return { containerClassnames }
}

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(App)
)
